import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI error boundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6">
          <div className="max-w-md text-center">
            <h1 className="font-display text-2xl font-medium mb-3">화면을 불러오지 못했습니다</h1>
            <p className="text-sm text-white/55 leading-relaxed mb-8">
              일시적인 오류가 발생했습니다. 새로고침하거나 홈으로 이동해 주세요.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="px-5 py-2.5 rounded-full bg-white text-black text-sm font-semibold"
              >
                새로고침
              </button>
              <a
                href="/"
                className="px-5 py-2.5 rounded-full border border-white/20 text-sm text-white/85"
              >
                홈으로
              </a>
            </div>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}
